import { createFileRoute } from "@tanstack/react-router";
import { PublicEventDetailPage } from "@/features/event-explorer/components/PublicEventDetailPage";

// クエリパラメータの型定義
interface EventCodeSearch {
  action?: "join";
}

export const Route = createFileRoute("/event-search/code/$event-code")({
  component: PublicEventDetailPage,
  validateSearch: (search: Record<string, unknown>): EventCodeSearch => {
    return {
      action: search.action === "join" ? "join" : undefined,
    };
  },
  loader: ({ params }) => {
    return { eventCode: params["event-code"] };
  },
});
